import React, {useState } from 'react'
import styles from './style.module.css'


function ToggleRadioButton({Value=false,handleChange}) {
    const [toggleValue,setToggleValue]=useState(Value)
  
   
// console.log("valuessssss",Value);

    const toggleButton = (value) => {   
        setToggleValue(value)
        handleChange(value)
       
             
    }

   
 
    return (
      <>
        <div
          onClick={() => toggleButton(!Value)}
          className={
            Value
              ? [`${styles.mode} ${styles.ratioRight} ${styles.dark}`]
              : [`${styles.mode} ${styles.ratioLeft} ${styles.light}`]
          }
        ></div>
      </>
    );
}

export default ToggleRadioButton